import {
  CommunicationIntegrationKind,
  IntegrationHealthStatus,
} from "@/types/communication-integration";

export type CommunicationChannelKind = "IN_APP" | "EMAIL" | "SMS" | "WHATSAPP";

export type ExternalCommunicationChannelKind = Exclude<
  CommunicationChannelKind,
  "IN_APP"
>;

export interface MessagingChannelConfig {
  id: string;
  hotelId: string;
  channel: CommunicationChannelKind;
  enabled: boolean;
  isDefault: boolean;
  channelMetadata: Record<string, unknown>;
  providerAvailable: boolean;
  integrationReady: boolean;
  integrationHealth: IntegrationHealthStatus | null;
  lastInboundError: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpsertMessagingChannelConfigRequest {
  enabled: boolean;
  isDefault?: boolean;
  channelMetadata?: Record<string, unknown>;
}

export const COMMUNICATION_CHANNEL_KINDS: readonly CommunicationChannelKind[] =
  ["IN_APP", "EMAIL", "SMS", "WHATSAPP"] as const;

export const CHANNEL_TO_INTEGRATION_KIND: Record<
  ExternalCommunicationChannelKind,
  CommunicationIntegrationKind
> = {
  EMAIL: "EMAIL",
  SMS: "TWILIO",
  WHATSAPP: "META_WHATSAPP",
};
